<div *ngIf="form && entity" editorType="large">
    <form [formGroup]="form">
      <div class="column">
        <dx-text-area [label]="'common.name' | translate | ucfirst" formField required formControlName="name"/>
      </div>
    </form>
    <div class="controls h-full">
      <dx-tab-panel class="h-full">
        <dxi-item [title]="'menu.slideMenu.technicalFeatures' | translate ">
          <div class="h-full flex flex-col">
            <dx-data-grid [glamResource]="techninalFeatures!" class="flex-1" [createComponent]="createGroupTechnicalFeatureComponent">
              <dxi-column dataField="technicalFeatureId" [visible]="false" />
              <dxo-editing class="hidden" [allowUpdating]="false" />
              <dxi-column [setCellValue]="setCellValue" sortOrder="asc" dataField="code" [caption]="'entity.code' | translate | ucfirst" editCellTemplate="cell-template-lookup">
                <div *dxTemplate="let data of 'cell-template-lookup'">
                    <dx-select-box (onValueChanged)="onFeatureSelected(data, $event.value)"
                                   [dataSource]="features"
                                   valueExpr="id"
                                   displayExpr="code"
                                   [searchMode]="'contains'"
                                   [searchExpr]="['code', 'name']"
                                   itemTemplate="lookup-item-template"
                    >
                    <div *dxTemplate="let feature of 'lookup-item-template'">
                      <gs-lookup-item [code]="feature.code" [name]="feature.name"/>
                    </div>
                    </dx-select-box>
                </div>
              <dxi-validation-rule type="required"/>
              </dxi-column>
              <dxi-column cellTemplate="cell-template-name" [allowEditing]="false" dataField="name" [caption]="'entity.name'| translate | ucfirst">
                <div *dxTemplate="let data of 'cell-template-name'">
                  {{data.data.name}}
                 </div>
              </dxi-column>
            </dx-data-grid>
          </div>
        </dxi-item>
      </dx-tab-panel>
    </div>
  </div>
  